<template>
  <div class="tabContent">
    <reports-sidebar :menuItems="menu" @toggle="changeReport" />

    <div class="reports-content-container">
      <div v-if="!selectedReport && !loading" class="warning-text">
        <div class="message-title">
          {{ $t("NoReportSelected") }}
        </div>
        <div class="message-description">
          {{ $t("SelectReportFromMenu") }}
        </div>
      </div>

      <div v-if="selectedReport && !selectedReport.page" class="warning-text">
        <div class="message-title">{{ $t("PageInConstruction") }}</div>
      </div>

      <component
        v-if="selectedReport && selectedReport.page"
        :is="selectedReport.page"
        :name="selectedReport.name"
        :version="selectedReport.version"
        :custom-json="selectedReport.customJson"
      />

      <loading-spinner
        :active.sync="loading"
        :is-full-page="false"
        color="#4fa2b7"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import LoadingSpinner from "vue-loading-overlay";
import NetworkStartingPointReport from "./ReportsPages/NSPR";
import ReportsSidebar from "./Sidebar/ReportsSidebar";
import BilOfMaterialsReport from "./ReportsPages/BOMBOQ";
import BilOfLaborsReport from "./ReportsPages/BOL";
import OpticalBudgetReport from "./ReportsPages/OpticalBudget";
import RawDataReport from "./ReportsPages/RawData";
import NetworkDiagramReport from "./ReportsPages/NetworkDiagram";
import NetworkDiagramWithSplicesReport from "./ReportsPages/NetworkDiagramWithSplices";
import SplicesReport from "./ReportsPages/Splices";
import FibersPathsReport from "./ReportsPages/FibersPaths";
import CentralOfficeFiberDistributionPlanReport from "./ReportsPages/COFiberDistributionPlan";
import CentralOfficeTrayPlanReport from "./ReportsPages/COTrayPlan";
import PrimaryNodeFiberDistributionPlanReport from "./ReportsPages/PNFiberDistributionPlan";
import PrimaryNodeTrayPlanReport from "./ReportsPages/PNTrayPlan";
import StatementOfWorkReport from "./ReportsPages/StatementOfWork";
import AsBuiltReport from "./ReportsPages/AsBuilt";
import BuildingsReports from "./ReportsPages/Buildings";
import MasksReport from "./ReportsPages/Masks";
import CablesReport from "./ReportsPages/Cables";
import InfrastructuresReport from "./ReportsPages/Infrastructures";
import WorkPackage from "@/components/Home/Content/Tabs/Reports/ReportsPages/WorkPackage";
import KMLReport from "./ReportsPages/KML";
import PhotosReport from "./ReportsPages/Photos";
import CoverageMapReport from "./ReportsPages/CoverageMap";
import NetworkMapReport from "@/components/Home/Content/Tabs/Reports/ReportsPages/NetworkMap";
import WorkPacks from "@/components/Home/Content/Tabs/Reports/ReportsPages/WorkPacks";
import GenericExport from "@/components/Home/Content/Tabs/Reports/ReportsPages/GenericExport";
import CustomReport from "@/components/Home/Content/Tabs/Reports/ReportsPages/CustomReport"

export default {
  name: "HomeReportsTab",

  components: {
    NetworkMapReport,
    WorkPackage,
    MasksReport,
    ReportsSidebar,
    BilOfMaterialsReport,
    BilOfLaborsReport,
    NetworkStartingPointReport,
    OpticalBudgetReport,
    RawDataReport,
    NetworkDiagramReport,
    NetworkDiagramWithSplicesReport,
    SplicesReport,
    FibersPathsReport,
    CentralOfficeFiberDistributionPlanReport,
    CentralOfficeTrayPlanReport,
    PrimaryNodeFiberDistributionPlanReport,
    PrimaryNodeTrayPlanReport,
    BuildingsReports,
    StatementOfWorkReport,
    AsBuiltReport,
    CablesReport,
    InfrastructuresReport,
    KMLReport,
    PhotosReport,
    CoverageMapReport,
    LoadingSpinner,
    WorkPacks,
    GenericExport,
    CustomReport
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      selectedReport: undefined,

      loading: false,

      menu: [
        {
          reference: "Budget",
          name: this.$i18n.t("Budget"),
          disabled: false,
          submenu: []
        },
        {
          reference: "NetworkWhole",
          name: this.$i18n.t("NetworkWhole"),
          disabled: false,
          submenu: []
        },
        {
          reference: "FeederNetwork",
          name: this.$i18n.t("FeederNetwork"),
          disabled: false,
          submenu: []
        },
        {
          reference: "DistributionNetwork",
          name: this.$i18n.t("DistributionNetwork"),
          disabled: false,
          submenu: []
        },
        {
          reference: "DropNetwork",
          name: this.$i18n.t("DropNetwork"),
          disabled: false,
          submenu: []
        },
        {
          reference: "CivilPlan",
          name: this.$i18n.t("CivilPlan"),
          disabled: false,
          submenu: []
        },
        {
          reference: "Other",
          name: this.$i18n.tc("Other", 1),
          disabled: false,
          submenu: []
        },
        {
          reference: "Custom",
          name: this.$i18n.t("Custom"),
          disabled: false,
          submenu: []
        }
      ]
    };
  },

  created() {
    this.getExportMapperTemplates();
  },

  methods: {
    ...mapActions(["fetchExportMapperTemplates"]),

    changeReport(report) {
      this.selectedReport = undefined;
      this.$nextTick(() => {
        this.selectedReport = report;
      });
    },

    getExportMapperTemplates() {
      this.loading = true;
      this.fetchExportMapperTemplates()
        .then(exportTemplates => {
          for (let template of exportTemplates) {
            let templateToAdd, parentNode;
            templateToAdd = this.getTemplateToAdd(template);
            if (template.level_export !== null) {
              parentNode = this.menu.find(
                item => item.reference === template["level_export"]
              );
              parentNode.submenu.push(templateToAdd);
            }
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    getTemplateToAdd(template) {
      return {
        name: this.getTemplateName(template),
        page: template.pageComponent,
        disabled: this.isTemplateDisabled(template),
        dev: template.inDevelopment,
        version: template.version,
        customJson: template.custom_report_json
      };
    },

    getTemplateName(template) {
      let name = template.order ? template.order + " - " : "";
      name += this.$i18n.tc(template.translation_name, 1); // Resolver quando é singular ou plural
      return name;
    },

    isTemplateDisabled(template) {
      return template.permission_name
        ? !this.userHasManagementPermission(template.permission_name)
        : template.disabled;
    }
  }
};
</script>

<style scoped>
.tabContent {
  background: #f8f8f8;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
}
.reports-content-container {
  width: calc(100% - 320px);
  height: 100%;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  color: #515358;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsTab.vue